<template>
  <div class="panel-body">
    <table
      class="table table-bordered bordered table-striped table-condensed datatable text-center"
    >
      <thead class="align-middle" style="background-color: #22577e">
        <tr>
          <th>No</th>
          <th>Nama</th>
          <th>Alamat</th>
          <th>Total Pasien</th>
          <th>Vaksin</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody
        v-for="(puskesmas, index) in getPuskesmas"
        :key="index"
        class="align-middle"
      >
        <tr>
          <td>{{ index + 1 }}</td>
          <td>{{ puskesmas.name }}</td>
          <td>{{ puskesmas.address }}</td>
          <td>{{ puskesmas.Schedules.length }}</td>
          <td>
            <ol
              class="list-inline"
              v-for="(vaccine, index) in puskesmas.Vaccines"
              :key="index"
            >
              <li class="text-center">{{ vaccine.name }}</li>
            </ol>
          </td>
          <td>
            <div class="d-flex">
              <button
                v-if="userRole == 'super_admin'"
                @click="udpatePuskesmas(puskesmas.id)"
                class="btn me-2"
                style="background-color: #97d5fc; padding : 2px "
              >
                <i class="bi-pencil-fill"></i>
                Perbaharui
              </button>
              <button
                @click="detailPuskesmas(puskesmas.id)"
                class="btn me-2"
                style="background-color: #f2789f; color: white; padding : 2px"
              >
                <span class="btn-label"><i class="bi-list-nested"></i></span>
                Rincian
              </button>
              <button
                v-if="userRole == 'super_admin'"
                @click="deletePuskesmas(puskesmas)"
                class="btn btn-danger"
                style="padding : 2px"
              >
                <span class="btn-label"><i class="fa fa-trash"></i></span>
                Hapus
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "PuskesmasRow",
  data: function () {
    return {
      userRole: localStorage.role,
    };
  },
  computed: {
    getPuskesmas() {
      return this.$store.state.puskesmas;
    },
    isLoading() {
      return this.$store.state.loading;
    },
    getVaccines() {
      return (payload) => {
        return payload.map((vax) => vax.name).join(",");
      };
    },
  },
  methods: {
    detailPuskesmas(id) {
      const puskesmasId = id;
      this.$router.push(`/puskesmasdetail/${puskesmasId}`);
      // this.$router.push({ name: 'PuskesmasDetail', params: 1 })
    },
    addPuskesmas() {
      this.$router.push(`/formaddpuskemas`);
    },
    udpatePuskesmas(id) {
      console.log(id, "ini id puskesmasnyaaaaa");
      this.$router.push(`/formupdatepuskesmas/${id}`);
    },
    deletePuskesmas(puskesmas) {
      this.$store.commit("SETLOADING", true);

      const puskesmasId = puskesmas.id;
      Swal.fire({
        title: `Apakah kamu akan menghapus data puskesmas ${puskesmas.name}?`,
        text: "Data puskesmas akan hilang jika anda menghapus tombol hapus",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText : "Batalkan",
        confirmButtonText: "Hapus"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.commit("PUSKESMASID", puskesmasId);
          this.$store
            .dispatch("deletePuskesmas")
            .then((response) => {
              this.$store.commit("SETLOADING", false);
              console.log(response.data);
              this.$store.dispatch("fetchPuskesmas");
              this.$vToastify.success({
                title : 'Sukses!',
                body: `Anda sudah menghapus puskesmas ${puskesmas.name} dari database`,
                theme : 'light'
              });
            })
            .catch((err) => {
              console.log(err.response.data);
            });
        }else{
          this.$store.commit("SETLOADING", false);
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
